import React from 'react';
import './speakerCardSection.scss';
import SpeakerCard from "./speakerCard";

export default class SpeakerCardSection extends React.Component {
    constructor(props) {
        super(props);

        this._templatingSpeakerCard = this._templatingSpeakerCard.bind(this);
    }


    static defaultProps = {
        className: '',
        avatarBaseUrl: '',
    };

    _templatingSpeakerCard(key) {
        return (
            <SpeakerCard key={key.fullName} noDetail={!key.biography} fullName={key.fullName} title={key.title} organization={key.organization}
                         photo={key.photo} onOpenSpeaker={this.props.speakerClickHandler}/>
        );
    }

    render() {
        return (
            <div className={"row justify-content-center"}>
                {this.props.data.map(this._templatingSpeakerCard)}
            </div>
        );
    }
}
